import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaHandsHelping, FaTasks, FaNewspaper, FaVideo, FaUsers, FaPhoneAlt } from 'react-icons/fa';
import './Header.css';
import irclogo from '../images/irclogo.png';
import IRC_Brochuree from '../images/IRC-Brochuree.pdf';

const Header = () => {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isSticky, setSticky] = useState(false);
    const location = useLocation();

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleBrochure = () => {
        const link = document.createElement("a");
        link.href = IRC_Brochuree; // must be inside public folder
        link.download = "IRC-Brochure.pdf";
        link.click();
    };

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`irc-header ${isSticky ? 'sticky' : ''}`}>
            <div className="header-top">
                <Link to="/" className="logo-link">
                    <div className="logo-container">
                        <img src={irclogo} alt="IRC Logo" className="logo" />
                        <div className="logo-text">
                            <p className="org-name">ISLAMIC RESEARCH CENTRE</p>
                            <p className="org-subname">EDUCATION & WELFARE TRUST</p>
                        </div>
                    </div>
                </Link>
                <div className="header-right">
                    <div className="header-buttons-group">
                        <a target="" rel="noopener noreferrer" className="war-button-wrapper">
                            <button
                                className="War-button"
                            >
                                WE DO NOT ACCEPT FOREIGN FUNDS
                            </button>
                        </a>

                        <div className="donate-brochure-row">
                            <a href="/help-us.html" target="" rel="noopener noreferrer">
                                <button className="donate-button">
                                    DONATE
                                </button>
                            </a>
                            <a href="/DonationDetails" target="" rel="noopener noreferrer">
                                <button
                                    className="Brochure-button"
                                    onClick={handleBrochure}
                                >
                                    BROCHURE
                                </button>
                            </a>
                        </div>
                    </div>

                   
                </div>
                 <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                        ☰
                    </button>
            </div>
            <nav className={`navbar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <ul className="nav-links">
                    <li className={location.pathname === '/' && !location.hash ? 'active' : ''}>
                        <Link to="/" onClick={() => setMobileMenuOpen(false)}><FaHome /> Home</Link>
                    </li>
                    <li className={location.hash === '#about' ? 'active' : ''}>
                        <Link to="/#about" onClick={() => setMobileMenuOpen(false)}><FaInfoCircle /> About Us</Link>
                    </li>
                    <li className={location.hash === '#activities' ? 'active' : ''}>
                        <Link to="/#activities" onClick={() => setMobileMenuOpen(false)}><FaTasks /> Activities</Link>
                    </li>
                    <li className={location.hash === '#news-media' ? 'active' : ''}>
                        <Link to="/#news-media" onClick={() => setMobileMenuOpen(false)}><FaNewspaper /> News & Blogs</Link>
                    </li>
                    <li className={location.hash === '#videos' ? 'active' : ''}>
                        <Link to="/#videos" onClick={() => setMobileMenuOpen(false)}><FaVideo /> TV & Medias</Link>
                    </li>
                    <li className={location.hash === '#help-us' ? 'active' : ''}>
                        <Link to="/#help-us" onClick={() => setMobileMenuOpen(false)}><FaHandsHelping /> Donate</Link>
                    </li>
                    <li className={location.hash === '#social-connects' ? 'active' : ''}>
                        <Link to="/#social-connects" onClick={() => setMobileMenuOpen(false)}><FaUsers /> Social Connects</Link>
                    </li>
                    <li className={location.hash === '#contacts' ? 'active' : ''}>
                        <Link to="/#contacts" onClick={() => setMobileMenuOpen(false)}><FaPhoneAlt /> Contacts</Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
















// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { FaHome, FaInfoCircle, FaHandsHelping, FaTasks, FaNewspaper, FaVideo, FaUsers, FaPhone } from 'react-icons/fa';
// import './Header.css';
// import irclogo from '../images/irclogo.png';
// import { initiateDonation } from '../services/paymentService';
// import IRC_Brochuree from '../images/IRC-Brochuree.pdf';




// const Header = () => {
//     const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [isSticky, setSticky] = useState(false);
//     const [isDonating, setIsDonating] = useState(false);

//     const location = useLocation();

//     const toggleMobileMenu = () => {
//         setMobileMenuOpen(!isMobileMenuOpen);
//     };

//     const handleDonateClick = async () => {
//         setIsDonating(true);
//         try {
//             // You can collect user data here if needed
//             const userData = {
//                 firstname: 'User', // You can get this from form or user profile
//                 email: 'user@example.com', // You can get this from form or user profile
//                 phone: '9999999999' // You can get this from form
//             };

//             await initiateDonation('1.00', userData);
//         } catch (error) {
//             console.error('Donation error:', error);
//             // Handle error (show message to user)
//         } finally {
//             setIsDonating(false);
//         }
//     };

//     const handleBrochure = () => {
//         const link = document.createElement("a");
//         link.href = IRC_Brochuree; // must be inside public folder
//         link.download = "IRC-Brochure.pdf";
//         link.click();
//     };

//     useEffect(() => {
//         const handleScroll = () => {
//             setSticky(window.scrollY > 50);
//         };
//         window.addEventListener('scroll', handleScroll);
//         return () => window.removeEventListener('scroll', handleScroll);
//     }, []);

//     return (
//         <header className={`irc-header ${isSticky ? 'sticky' : ''}`}>
//             <div className="header-top">
//                 <Link to="/" className="logo-link">
//                     <div className="logo-container">
//                         <img src={irclogo} alt="IRC Logo" className="logo" />
//                         <div className="logo-text">
//                             <p className="org-name">ISLAMIC RESEARCH CENTRE</p>
//                             <p className="org-subname">EDUCATION & WELFARE TRUST</p>
//                         </div>
//                     </div>
//                 </Link>
//                 <div className="header-right">
//                     <button
//                         className="donate-button"
//                         onClick={handleDonateClick}
//                         disabled={isDonating}
//                     >
//                         {isDonating ? 'Processing...' : 'DONATE'}
//                     </button>

//                     <a href="https://pmny.in/HJ2AWtxjLqtp" target="_blank" rel="noopener noreferrer">
//                         <button className="donate-button">
//                             Donate
//                         </button>
//                     </a>

//                     <button
//                         className="Brochure-button"
//                         onClick={handleBrochure}
//                     >
//                         BROCHURE
//                     </button>
//                     <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
//                         ☰
//                     </button>
//                 </div>
//             </div>
//             <nav className={`navbar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
//                 <ul className="nav-links">
//                     <li className={location.pathname === '/' && !location.hash ? 'active' : ''}>
//                         <Link to="/" onClick={() => setMobileMenuOpen(false)}><FaHome /> Home</Link>
//                     </li>
//                     <li className={location.hash === '#about' ? 'active' : ''}>
//                         <Link to="/#about" onClick={() => setMobileMenuOpen(false)}><FaInfoCircle /> About Us</Link>
//                     </li>
//                     <li className={location.hash === '#activities' ? 'active' : ''}>
//                         <Link to="/#activities" onClick={() => setMobileMenuOpen(false)}><FaTasks /> Activities</Link>
//                     </li>
//                     <li className={location.hash === '#news-media' ? 'active' : ''}>
//                         <Link to="/#news-media" onClick={() => setMobileMenuOpen(false)}><FaNewspaper /> News & Media</Link>
//                     </li>
//                     <li className={location.hash === '#videos' ? 'active' : ''}>
//                         <Link to="/#videos" onClick={() => setMobileMenuOpen(false)}><FaVideo /> Video Gallery</Link>
//                     </li>
//                     <li className={location.hash === '#help-us' ? 'active' : ''}>
//                         <Link to="/#help-us" onClick={() => setMobileMenuOpen(false)}><FaHandsHelping /> Donate Us</Link>
//                     </li>
//                     <li className={location.hash === '#social-connects' ? 'active' : ''}>
//                         <Link to="/#social-connects" onClick={() => setMobileMenuOpen(false)}><FaUsers /> Social Connects</Link>
//                     </li>
//                     <li className={location.hash === '#contacts' ? 'active' : ''}>
//                         <Link to="/#contacts" onClick={() => setMobileMenuOpen(false)}><FaPhone /> Contact</Link>
//                     </li>
//                 </ul>
//             </nav>
//         </header>
//     );
// };

// export default Header;